// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3zCYC","header":"footer-module--header--1_I8B","text":"footer-module--text--2cTRh"};